module.exports = __webpack_public_path__ + "static/media/checklist_illustration.5ef91352.png";